import Vue from 'vue';
import './plugins/axios';
import App from './App.vue';
import router from '@/router';
import store from '@/store/index';
import './registerServiceWorker';
import './plugins/element.js';
import 'nprogress/nprogress.css';

import VueAreaLinkage from 'vue-area-linkage';
import 'vue-area-linkage/dist/index.css';
Vue.use(VueAreaLinkage);
// 自定义指令
import './directive/index';
Vue.config.productionTip = false;

import VueAMap from 'vue-amap';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
	key: '1cc4534f215bcd631e6426ea3cb7c233',
	plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType'],
	v: '1.4.4',
	uiVersion:'1.0'
});

// muse-ui
// import MuseUI from 'muse-ui'
// import 'muse-ui/dist/muse-ui.css'
// Vue.use(MuseUI)

// v-charts
import VCharts from 'v-charts'
Vue.use(VCharts)
import _ from 'lodash'
Vue.prototype._ = _
const app = new Vue({
  router,
  store,
  render: h => h(App),
})//.$mount('#app');
app.$store.dispatch('initData').then((data)=>{
	app.$mount('#app')
})


window.APP = app ;
